import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ProblemModel } from './model';
import { ProblemState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { DomSanitizer } from '@angular/platform-browser';
import { UserFacade } from '../user/facade';

@Injectable()
export class ProblemFacade {
  private store = inject<Store<ProblemState>>(Store);
  private sanitizer = inject(DomSanitizer);
  private userFacade = inject(UserFacade);

  allProblems$ = this.store.pipe(select(selectors.selectAll));

  constructor() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.getAll();
      }
    });
  }

  public getAll() {
    this.store.dispatch(new actions.LoadRequestAction());
  }

  getById(id: number): Observable<ProblemModel> {
    return this.store.pipe(select(selectors.selectById(id)));
  }

  loadProblems() {
    this.store.dispatch(new actions.LoadRequestAction());
  }

  createProblem(problem: ProblemModel) {
    this.store.dispatch(new actions.CreateRequestAction(problem));
  }

  saveProblem(problem: ProblemModel) {
    this.store.dispatch(new actions.SaveRequestAction(problem));
  }

  deleteProblem(id: number) {
    this.store.dispatch(new actions.DeleteRequestAction(id));
  }

  selected(): Observable<ProblemModel> {
    return this.store.pipe(select(selectors.selectSelected));
  }

  setSelected(id: number) {
    this.store.dispatch(new actions.SetSelectedRequestAction(id));
  }

  solvedProblem(id: number) {
    this.store.dispatch(new actions.SolvedRequestAction(id));
  }

  getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }

  convertImage(problem: ProblemModel): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`data:${problem.type};base64,${problem.image}`);
  }
}
